import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FadeIn from "@/components/FadeIn";

/**
 * Generic internal-link block used for "Dienstpagina's", "Sectoren",
 * "Relevante diensten" and "Gerelateerde inzichten".
 */
export default function InternalLinkBlock({
  eyebrow,
  title,
  intro,
  items = [],
  columns = 1,
  background = "#FFFFFF",
  testid = "internal-link-block",
}) {
  if (items.length === 0) return null;

  return (
    <section
      className="section"
      style={{ backgroundColor: background }}
      data-testid={testid}
    >
      <div className={columns > 1 ? "container-soveu" : "container-soveu max-w-3xl"}>
        <FadeIn className="mb-8 max-w-3xl">
          {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
          <h2 className="h2-display mb-4">{title}</h2>
          {intro && (
            <p className="text-[#334155] body-lg leading-relaxed">{intro}</p>
          )}
        </FadeIn>

        <div
          className={
            columns > 1 ? "grid md:grid-cols-2 gap-4" : "space-y-3"
          }
        >
          {items.map((item, i) => (
            <FadeIn key={item.to} delay={i * 50}>
              <Link
                to={item.to}
                className="flex items-start justify-between gap-4 p-5 rounded-md border border-[#E5E9EF] bg-white hover:border-[#1E3A5F] transition-colors h-full"
                data-testid={`link-item-${item.to.replace(/\//g, "-").replace(/^-/, "")}`}
              >
                <div className="flex-1">
                  {item.eyebrow && (
                    <div
                      className="text-[12px] uppercase tracking-wide font-medium mb-1.5"
                      style={{ color: "#6B7280" }}
                    >
                      {item.eyebrow}
                    </div>
                  )}
                  <div
                    className="text-[16px] font-semibold leading-snug"
                    style={{ color: "#1E3A5F" }}
                  >
                    {item.label}
                  </div>
                  {item.summary && (
                    <p className="text-[14px] text-[#334155] leading-relaxed mt-2">
                      {item.summary}
                    </p>
                  )}
                </div>
                <ArrowRight
                  size={18}
                  className="flex-shrink-0 mt-1.5"
                  style={{ color: "#2D6F8F" }}
                />
              </Link>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
